import { DefaultApiSubscribeNewsletterRequest } from '@/api-client/autogenerated';
import { getApiClient } from '@/api-client/api-client';

export const subscribeNewsletter = async (
  params: DefaultApiSubscribeNewsletterRequest,
) => {
  const res = await getApiClient().subscribeNewsletter(params);
  return res.data;
};
